'use client';

import { Suspense } from 'react';
import { useEmbedResumeability } from '../../../hooks/useEmbedResumability';

const InnerEmbedResumabilityComponent = () => {
    useEmbedResumeability();
    return null;
};
export const EmbedResumability = () => {
    return (
        <Suspense>
            <InnerEmbedResumabilityComponent />
        </Suspense>
    );
};
